import { render, staticRenderFns } from "./RightClickMenu.vue?vue&type=template&id=2ca5d6e6&"
import script from "./RightClickMenu.vue?vue&type=script&lang=ts&"
export * from "./RightClickMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports